module.exports = __webpack_public_path__ + "img/exp1.6150ccee.png";